(() => {
  const script = document.querySelector('script[src*="yotpo-referral-auth.js"]');
  const loginUrl = script?.dataset.loginUrl;

  if (!loginUrl) return;

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const button = target?.closest(
        '.yotpo-widget-referral-share .yotpo-login-link button, ' +
          '.yotpo-widget-referral-share button[data-cy="login-login-button"]',
      );

      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const destination = new URL(loginUrl, window.location.origin);
      destination.searchParams.set(
        'return_url',
        `${window.location.pathname}${window.location.search}`,
      );
      window.location.assign(destination.href);
    },
    true,
  );
})();